import api from '../services/api';
import { querystring } from '../utils/resposta';

// Pedido de interesse em ser PATROCINADOR do projeto (vira banner no app e no site).
// Mesmo desenho dos pedidos de perfil Profissional e de apoiador: quem tem interesse
// envia o pedido pelo site, ele cai no painel e o administrador aprova ou recusa.
//
// Aprovar só MARCA o pedido: o banner exige imagem e link, que o pedido não traz, e
// a combinação comercial é fora do sistema. O administrador cadastra o banner em
// Conteúdo > Banners (o painel leva os dados do pedido para o formulário).
export const MAX_MENSAGEM = 500;
export const MIN_MENSAGEM = 10;

const SolicitacaoPatrocinador = {
  model: { empresa: '', link: '', mensagem: '' },

  // { solicitacao, contato } — o pedido mais recente (ou null) e o e-mail/celular do
  // PERFIL, que a administração usa para responder.
  minha: async function () {
    return await api.get('/solicitacoes-patrocinador/minha')
      .then(response => response)
      .catch(error => error);
  },

  create: async function (data) {
    return await api.post('/solicitacoes-patrocinador', data)
      .then(response => response)
      .catch(error => error);
  },

  // Administrador
  findAll: async function (page = 1, limit = 10, status = '') {
    return await api.get(`/solicitacoes-patrocinador/all/${page}/${limit}${querystring({ status })}`)
      .then(response => response)
      .catch(error => error);
  },

  contagem: async function () {
    return await api.get('/solicitacoes-patrocinador/contagem')
      .then(response => response)
      .catch(error => error);
  },

  aprovar: async function (id, resposta) {
    return await api.patch(`/solicitacoes-patrocinador/${id}/aprovar`, resposta ? { resposta } : {})
      .then(response => response)
      .catch(error => error);
  },

  recusar: async function (id, resposta) {
    return await api.patch(`/solicitacoes-patrocinador/${id}/recusar`, { resposta })
      .then(response => response)
      .catch(error => error);
  },
  // Desabilitar tira o apoio do site e do app sem apagar nada; habilitar volta.
  // So para pedido aprovado (o backend responde 409 nos demais).
  desabilitar: async function (id) {
    return await api.patch(`/solicitacoes-patrocinador/${id}/desabilitar`)
      .then(response => response)
      .catch(error => error);
  },

  habilitar: async function (id) {
    return await api.patch(`/solicitacoes-patrocinador/${id}/habilitar`)
      .then(response => response)
      .catch(error => error);
  },
};

export default SolicitacaoPatrocinador;
